import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { IoMdCloudUpload } from 'react-icons/io';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const UploadFile = ({ onFileChange }) => {
  const [fileValue, setFileValue] = useState('');
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    onFileChange(selectedFile);
    setFileValue('');
  };

  const { t } = useTranslation();
  const ControlsTranslations = useSelector((state) => state.WebsiteLanguage.data.ControlsTranslations);
  return (
    <div className="file-upload">
      <Button component="label" variant="contained" startIcon={<IoMdCloudUpload />}>
        {ControlsTranslations.upload !== undefined ? ControlsTranslations.upload : `${t('add-edit.uploadfile')}`}
        <VisuallyHiddenInput value={fileValue} type="file" onChange={handleFileChange} onClick={() => setFileValue('')} />
      </Button>
    </div>
  );
};

export default UploadFile;